import { Component, OnInit, signal, computed, input, output, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NgScrollbar } from 'ngx-scrollbar';
import { FormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { TeamMemberSimple } from '../../../store/team-management/team-management.interfaces';
import { FloatingInputComponent } from '../../inputs/floating-input/floating-input.component';
import { getInitials } from '../../../store/activities/activities.constants';
import { viewProjectActions } from '../../../store/view-project/view-project.actions';
import { viewProjectSelectors } from '@app/store/view-project/view-project.selectors';
import { LoadingSpinnerComponent } from '@app/framework/loading-animation/loading-spinner.component';

@Component({
  selector: 'app-assign-teammate-table',
  imports: [FloatingInputComponent, NgScrollbar, FormsModule, LoadingSpinnerComponent],
  templateUrl: './assign-teammate-table.component.html',
  styleUrl: './assign-teammate-table.component.scss',
})
export class AssignTeammateTableComponent implements OnInit {
  private readonly store = inject(Store);

  projectId = input<number | undefined>();
  inputTeammates = input<TeamMemberSimple[]>();

  teammateSelected = output<TeamMemberSimple>();

  storeTeammates = toSignal(this.store.select(viewProjectSelectors.selectTeamMembers));

  searchText = signal<string>('');

  displayedTeammates = computed(() => {
    const search = this.searchText();

    const mates = this.inputTeammates() ? this.inputTeammates() : this.storeTeammates();

    const filtered = search
      ? mates.filter((teammate) => {
          const name = `${teammate.first_name} ${teammate.last_name}`;
          return name.toLowerCase().includes(search.toLowerCase());
        })
      : mates;

    return filtered.map((teammate) => ({
      ...teammate,
      initials: getInitials(teammate),
    }));
  });

  isLoading = toSignal(this.store.select(viewProjectSelectors.selectTeamMembersIsLoading));
  fetchTeammates = signal(true);

  ngOnInit(): void {
    if (this.fetchTeammates()) {
      this.store.dispatch(
        viewProjectActions.loadProjectTeamMembers({ projectId: this.projectId() }),
      );
    }
  }

  searchTeammates(searchText: string) {
    this.searchText.set(searchText);
  }

  onTeammateSelect(teammate: TeamMemberSimple) {
    this.teammateSelected.emit(teammate);
  }
}
